export default "__VITE_ASSET__D3QZevA9__"